<dialog #_innerModal eclModal [variant]="'information'" [size]="'m'"
        (modalClose)="modalClose.emit($event)">
    <header eclModalHeader>
        {{ 'easeportal.modal.MEMBER-STATE' | translate }}
    </header>
    <div eclModalBody isScrollable>
        <p class="ecl-u-mr-2xl">{{ 'easeportal.member-state-modal.CONTENT' | translate}}</p>
        <p class="ecl-u-mb-2xl"><strong>{{'easeportal.member-state-modal.CHOICE-TEXT'| translate}}</strong></p>
    </div>
    <footer eclModalFooter>
        <button eclButton eclModalRole="confirm"
                [eclModalClose]="memberStatesEnums.SINCERE_COOPERATION"
                variant="secondary">{{ 'easeportal.common.SINCERE-COOPERATION' | translate }}</button>
        <button eclButton eclModalRole="confirm"
                [eclModalClose]="memberStatesEnums.REGULATION_EC_NO_1049_2001"
                variant="secondary">{{ 'easeportal.common.REGULATION-EC' | translate }}</button>
    </footer>
</dialog>
